import type {
  PaginatedResult,
  PanelCreateContractInput,
  PanelCreditContractDto,
  PanelCreditLedgerEntryDto,
  PanelCreditOverviewDto,
  PanelCreditReversalDto,
  PanelGrantCreditsInput,
  PanelGrantCreditsResultDto,
  PanelReverseCreditsInput,
  PanelTerminateContractInput,
} from '@icebreaker/shared';
import { api } from '@/shared/api/client';

/**
 * Kurum kredisi `api` katmanı — YALNIZCA sagadan çağrılır. Yazma yanıtları
 * kurum kimliğiyle birlikte döner: saga hangi kurumun özetini ve defterini
 * tazeleyeceğini yanıttan okur (invalidation `INVALIDATION_MAP`
 * `panelCredits/*`). Tutar ya da para alanı hiçbir gövdede yoktur.
 */
export async function fetchCreditOverview(organizationId: string): Promise<PanelCreditOverviewDto> {
  return await api.panelCredits.overview(organizationId);
}

export async function fetchCreditLedger(input: {
  readonly organizationId: string;
  readonly page: number;
  readonly pageSize: number;
}): Promise<PaginatedResult<PanelCreditLedgerEntryDto>> {
  return await api.panelCredits.ledger(input.organizationId, {
    page: input.page,
    pageSize: input.pageSize,
  });
}

export async function grantCredits(input: {
  readonly organizationId: string;
  readonly body: PanelGrantCreditsInput;
}): Promise<{ organizationId: string; grant: PanelGrantCreditsResultDto }> {
  const grant = await api.panelCredits.grant(input.organizationId, input.body);
  return { organizationId: input.organizationId, grant };
}

export async function reverseCredits(input: {
  readonly organizationId: string;
  readonly grantId: string;
  readonly body: PanelReverseCreditsInput;
}): Promise<{ organizationId: string; reversal: PanelCreditReversalDto }> {
  const reversal = await api.panelCredits.reverse(input.organizationId, input.grantId, input.body);
  return { organizationId: input.organizationId, reversal };
}

export async function createContract(input: {
  readonly organizationId: string;
  readonly body: PanelCreateContractInput;
}): Promise<{ organizationId: string; contract: PanelCreditContractDto }> {
  const contract = await api.panelCredits.createContract(input.organizationId, input.body);
  return { organizationId: input.organizationId, contract };
}

export async function terminateContract(input: {
  readonly organizationId: string;
  readonly contractId: string;
  readonly body: PanelTerminateContractInput;
}): Promise<{ organizationId: string; contract: PanelCreditContractDto }> {
  const contract = await api.panelCredits.terminateContract(
    input.organizationId,
    input.contractId,
    input.body,
  );
  return { organizationId: input.organizationId, contract };
}
